const TRANSLATION = {
  common: {
    loading: '読み込み中',
  },
  i18n: {
    English: '英語',
    Spanish: 'スペイン語',
    Russian: 'ロシア語',
    'Portuguese (Brazil)': 'ポルトガル語（ブラジル）',
    Indonesian: 'インドネシア語',
    Czech: 'チェコ語',
    German: 'ドイツ語',
    French: 'フランス語',
    Italian: 'イタリア語',
    Dutch: 'オランダ語',
    Polish: 'ポーランド語',
    Vietnamese: 'ベトナム語',
    Turkish: 'トルコ語',
    Ukrainian: 'ウクライナ語',
    Chinese: '簡体字中国語',
    'Traditional Chinese': '繁体字中国語',
    Japanese: '日本語',
    Korean: '韓国語',
    Arabic: 'アラビア語',
    Persian: 'ペルシャ語',
    Thai: 'タイ語',
    Hindi: 'ヒンディー語',
    Malay: 'マレーシア語',
    province: {
      Hebei: '河北省（ホーペイしょう）',
      Shanxi: '山西省（シャンシーしょう）',
      Liaoning: '遼寧省（リャオニンしょう）',
      Jilin: '吉林省（チーリンしょう）',
      Heilongjiang: '黒竜江省（ヘイロンジャンしょう）',
      Jiangsu: '江蘇省（ジャンスーしょう）',
      Zhejiang: '浙江省（ジェッジャンしょう）',
      Anhui: '安徽省（アンホイしょう）',
      Fujian: '福建省（フージェンしょう）',
      Jiangxi: '江西省（ジャンシーしょう）',
      Shandong: '山東省（シャントンしょう）',
      Henan: '河南省（ホナンしょう）',
      Hubei: '湖北省（フーベイしょう）',
      Hunan: '湖南省（フーナンしょう）',
      Guangdong: '広東省（カントンしょう）',
      Hainan: '海南省（ハイナンしょう）',
      Sichuan: '四川省（シーチュアンしょう）',
      Guizhou: '貴州省（グイジョウしょう）',
      Yunan: '雲南省（ユンナンしょう）',
      Shaanxi: '陝西省（シャンシーしょう）',
      Gansu: '甘粛省（ガンスーしょう）',
      Qinghai: '青海省（チンハイしょう）',
      Taiwan: '台湾省（タイワンしょう）',
      Guangxi: '広西チワン族自治区（コウセイちわんぞくじちく）',
      Neimenggu: '内モンゴル自治区（うちモンゴルじちく）',
      Tibet: 'チベット自治区（チベットじちく）',
      Ningxia: '寧夏回族自治区（ネイカかいぞくじちく）',
      Xinjiang: '新疆ウイグル自治区（しんきょうウイグルじちく）',
      HongKong: '香港特別行政区（ホンコンとくべつぎょうせいく）',
      Macau: 'マカオ特別行政区（マカオとくべつぎょうせいく）',
      Beijing: '北京市（ペキンし）',
      Tianjin: '天津市（テンシンし）',
      Shanghai: '上海市（シャンハイし）',
      Chongqing: '重慶市（チョンチンし）',
    },
  },
  pageHeader: {
    product: '製品',
    tvcTest: '横画面-クリエイティブ診断',
    tvcEval: '横画面-ディープインサイト',
    contactUs: 'お問い合わせ',
    Pricing: '料金プラン',
    Dashboard: '今すぐ始める',
    signIn: 'ログイン',
    signUp: '登録',
    resourceCenter: 'リソースセンター',
    all: 'すべて',
    news: 'ニュース',
    insight: 'インサイト',
    case: '事例',
  },
  productSwitch: {
    common: {
      comingSoon: '近日公開',
    },
    modal: {
      heroTitle: '実施するテストをお選びください',
      heroSubtitle: 'AdEff は、必要なときにいつでも多面的なクリエイティブインサイトを提供します。',
      remainingTimes: '残り回数：{{count}}',
      supportedAssets: '対応素材',
      coreMetrics: '主要指標',
      cognitiveNeuroscienceIndicators: '認知神経指標',
      consumerAttitudeIndicators: '消費者態度指標',
      outputResult: '出力結果',
      dataReport: 'データレポート',
      analysisReport: '分析レポート',
      accessBackend: '今すぐ始める',
      tabs: {
        tvc: '横画面クリエイティブテスト',
        portrait: '縦画面クリエイティブテスト',
      },
      cards: {
        tvcQuick: {
          title: '横画面-クイックテスト',
          descriptionHighlight: '複数案から最適案を選定し、迅速に意思決定',
        },
        tvcBase: {
          title: '横画面-クリエイティブ診断',
          descriptionHighlight: 'クリエイティブの細部まで磨き上げ、実践的な改善提案をご提供します',
          value1: '10〜60秒のTVC/OTVクリエイティブ',
          value2: '認知神経指標',
        },
        tvcSurvey: {
          title: '横画面-ディープインサイト',
          descriptionHighlight: '多角的にクリエイティブを評価し、最適化戦略のガイダンスを提供します',
          value1: '10〜60秒のTVC/OTVクリエイティブ',
          value2: '認知神経指標',
        },
        portraitQuick: {
          title: '縦画面-クイックテスト',
          descriptionHighlight: '複数案から最適案を選定し、迅速に意思決定',
        },
        portraitBase: {
          title: '縦画面-クリエイティブ診断',
          descriptionHighlight: 'クリエイティブの細部まで磨き上げ、実践的な改善提案をご提供します',
          value1: '5〜90秒の縦型クリエイティブ',
          value2: '認知神経指標',
        },
        portraitSurvey: {
          title: '縦画面-ディープインサイト',
          descriptionHighlight: '多角的にクリエイティブを評価し、最適化戦略のガイダンスを提供します',
          value1: '5〜90秒の縦型クリエイティブ',
          value2: '認知神経指標',
        },
      },
    },
    hoverPanel: {
      columns: {
        tvc: {
          bannerTitle: '横画面クリエイティブテスト',
          assetText: '10〜60秒のTVC/OTVクリエイティブに対応',
        },
        portrait: {
          bannerTitle: '縦画面クリエイティブテスト',
          assetText: '5〜90秒の縦型クリエイティブに対応',
        },
      },
      items: {
        tvcQuick: {
          description: 'スピーディかつ正確に、最適なクリエイティブを選定',
        },
        tvcBase: {
          title: 'クリエイティブ診断',
          description: '1秒単位の最適化で、クリエイティブを磨き上げます',
        },
        tvcSurvey: {
          title: 'ディープインサイト',
          description: '全方位分析で課題を特定します',
        },
        portraitBase: {
          title: 'クリエイティブ診断',
          description: '1秒単位の最適化で、クリエイティブを磨き上げます',
        },
        portraitQuick: {
          description: 'スピーディかつ正確に、最適なクリエイティブを選定',
        },
        portraitSurvey: {
          title: 'ディープインサイト',
          description: '全方位分析で課題を特定します',
        },
      },
    },
  },
  cookieAcceptNotification: {
    title: 'クッキーの使用について',
    desc: '当社は、ウェブサイトの正常な動作を確保するために必要なクッキーを使用しています。あなたの同意のもと、分析クッキーを使用してユーザー体験を向上させます。プライバシーポリシーでクッキーポリシーをご覧ください。',
    btn1: 'すべて拒否',
    btn2: 'すべて受け入れる',
    cookiePolicy: 'クッキーポリシー',
  },
  landing: {
    banner: {
      text1: 'AI駆動',
      text2: '広告',
      text3: 'テスト',
      text4: 'クリエイティブテスト＆最適化プラットフォーム',
      feature1: 'コンテンツデコード',
      feature2: 'フィードバック予測',
      feature3: 'データ統合',
      feature4: '結論推論',
      btn1: 'デモを取得',
      btn2: 'プロジェクトを作成',
    },
    info: {
      title:
        '超グラフ・マルチモーダル大規模言語モデル（HMLLM）*に基づき、クリエイティブの効果を素早く予測し、広告の投資対効果（ROI）を向上させます。',
      subTitle: '*本モデルは、大規模なニューロマーケティングテストとマルチエージェントの構築に基づいています。',
      detail1: '快速広告テスト',
      detail1Desc:
        'AdEffなら、わずか15分でターゲットの視線（アテンション）カーブ、感情の起伏、クリエイティブコンテンツへのエンゲージメントを把握し、詳細な評価レポートと最適化のガイダンスを提供します。',
      detail2: '最適なクリエイティブの迅速なスクリーニング',
      detail2Desc:
        'AdEffは複数のクリエイティブを同時に測定し、ブランドの迅速な意思決定を支援します。詳細な比較分析も提供します。',
      detail3: 'ワンクリック編集で、効果的な多彩なバリエーションを生成',
      detail3Desc:
        'AdEffはワンクリック編集に対応しており、さまざまな配信シーンに合わせた効果的なバリエーションを素早く生成できます。',
    },
    advantages: {
      title: 'AdEffの特長',
      item1Title: '迅速なレスポンス',
      item1Desc: '最短<tmp>15分</tmp>でレポートを取得可能。',
      item2Title: '独自のAIモデル',
      item2Desc: 'オーディエンスフィードバックに基づく独自の<tmp>AIモデル</tmp>。',
      item3Title: '可視化グラフ',
      item3Desc:
        '<tmp>可視化グラフ</tmp>＋AI自動解説、テストレポートをワンクリックで生成',
      item4Title: '圧倒的なデータ規模',
      item4Desc: '<tmp>50,000件以上</tmp>のクリエイティブデータベース',
      item5Title: '専門家チーム',
      item5Desc: '<tmp>専門家チーム</tmp>によるサポートとガイダンス',
    },
    service: {
      title: 'AdEffのサービス形態',
      desc: 'ご希望のサービス形態をお選びください',
      topTitle: 'オンラインセルフサービス',
      topRow1: 'ご自身でプロジェクトを作成しテストを実施',
      topRow2: '可視化グラフ＋AI解説レポート',
      topRow3: '客観的神経科学指標分析（視線＋脳波）',
      topRow4: '独自AIモデルによるテスト',
      bottomTitle: '専門家チームサービス',
      bottomRow1: '専門家がプロジェクトを作成しテストを実施',
      bottomRow2: '客観的神経科学指標分析（視線＋脳波）、主観指標の追加も選択可能',
      bottomRow3: '可視化グラフ＋専門家による解説レポート',
      bottomRow4: '独自AIモデルテスト、実人サンプルテストも選択可能',
    },
    footer: {
      title:
        'AdEffは超グラフ・マルチモーダル大規模言語モデル（HMLLM）を基盤とし、超グラフによって視覚要素とEEG（脳波）信号および視線追跡データの複雑な関係を構築することで、広告クリエイティブの迅速なテストを実現します。',
      email: 'メールアドレス',
      belongDesc: '<tmp>マイニングランプテクノロジー</tmp>製品',
    },
    startBtn: '今すぐ始める',
  },
  contact: { title: 'お問い合わせ', copy: 'コピー', message: { success: 'コピー成功' } },
  pricing: {
    title: 'AI駆動のクリエイティブテスト＆最適化エキスパート',
    starter: {
      title: 'ベーシックプラン',
      desc_1: '一回限りのテストに最適で、購入後すぐに使用可能',
      desc_2: '少数テスト向け、購入後すぐにご利用いただけます',
      timesDesc: '<strong>{{count}}</strong>回のテスト',
      timesDesc1: '<strong>{{count}}</strong>回のテスト',
      discount: '期間限定50%オフ',
      originPrice: '原価',
      desc2: 'オーディエンスフィードバックに基づく超グラフマルチモーダル大規模言語モデル',
      desc3: '迅速なレスポンス、最短15分でレポートを生成',
      desc4: '豊富な可視化グラフ',
      desc5: 'プロフェッショナルなAI自動解説',
      desc6: 'グローバルデータベースとベンチマーク',
      cardDesc1: '期間限定特別価格：1回わずか{{pricePerTest}}',
      cardDesc2: '回数は永年有効',
    },
    premium: {
      time: '回',
    },
    unlimited: {
      title: 'アンリミテッドプラン',
      cardDesc1: '1回あたり{{pricePerTest}}～',
      cardDesc2: '回数の有効期限は1年間',
      cardDesc3: 'カスタムベンチマーク値',
      planDesc500: '年間500回のテストが使い放題',
      planDesc1000: '年間1,000回のテストが使い放題',
    },
    benefits: {
      title: 'AdEffを選ぶ理由',
      subtitle: 'AdEffをご購入いただくと、以下の特典がご利用いただけます：',
      expertSupport: '専門家チームによるサポートとガイダンス',
      moreNeedsTitle: 'その他のご購入ニーズがおありですか？',
      customPlanPrefix: '柔軟なカスタマイズプランもご用意しております。',
      customPlanSuffix: 'までお気軽にお問い合わせください。',
    },
    subscribeBtn: '今すぐ購読',
    contactUs: 'お問い合わせ',
  },
  login: {
    loginText: 'ログイン',
    signUpText: '<tmp>無料登録</tmp>',
    text1: 'チームに正常に参加しました',
    text1Desc: '広告テストを続けることができます',
    text2: 'ユーザーが会社に参加しました',
    text3: 'チームの招待が期限切れです',
    text4: 'チームの招待リンクは無効です。',
    optionText1: 'すでにアカウントをお持ちですか？',
    optionText2: 'アカウントをお持ちでない方は',
    alertText1: '登録により、',
    alertText2: '登録により、',
    termsOfService: '利用規約',
    privacy: 'プライバシーポリシー',
    agreementSuffix: 'に同意したものとみなします',
    privacyTips: '登録前に利用規約への同意チェックをお願いします',
    and: 'と',
    or: 'または',
    next: '次へ',
    googleLogin: 'Googleでログイン',
    googleSignUp: 'Googleアカウントで登録',
    loginWithEmail: 'メールでログイン',
    signUpWithEmail: 'メールアドレスで登録',
    password: 'パスワード',
    emailAddress: 'アカウント',
    enterEmail: 'メールアドレスを入力してください',
    enterPassword: 'パスワードを入力してください',
    confirmPassword: 'パスワードを確認',
    forgotPassword: 'パスワードをお忘れですか？',
    inconsistentPassword: 'パスワードが一致しません',
    verificationCode: '認証コード',
    emptyVerificationCode: '確認コードは空にできません',
    enterVerificationCode: '認証コードを入力してください',
    sendedVerificationCode: '認証コードをメールアドレス宛に送信しました',
    emailOrPasswordNotCorrect: 'メールアドレスまたはパスワードが正しくありません。',
    message: {
      text1: '入力内容が無効です',
      text2: 'このメールアドレスは既に登録されています',
      text3: '確認コードの検証エラー！',
      text4: 'このアカウントは企業にバインドされていません。再度バインドしてください！',
      text5: '正しいメールアドレス形式で入力してください',
      text6: 'パスワードは12文字以上必要です',
      text7: 'パスワードには大文字・小文字・数字を含める必要があります',
      requestLimit: 'リクエスト制限を超えました。後でもう一度お試しください。',
    },
  },
  resetPwdPage: {
    submit: '送信',
    emailNotFound: 'メールアドレスを確認してください',
    emailHasSent: 'メールは {{email}} に送信されました',
    checkYourInbox: 'メールをご確認ください',
    resetYourPassword: 'パスワードをリセット',
    resetLinkHasSent:
      'パスワードリセット用のリンクを登録メールアドレス宛に送信しました。メールをご確認ください。',
    enterYourEmailAddress:
      'メールアドレスを入力してください',
    didNotGetEmail: 'メールが届かない場合は？',
    tryAgain: '再送信',
    goBackToSign: 'ログインページに戻る',
    email: 'メールアドレス',
    enterYourEmail: 'メールアドレスを入力してください',
    resetPassword: 'パスワードをリセット',
    resetPwdSuccess: 'パスワードが正常にリセットされました',
    message: {
      resetLinkCodeError: 'リンクのコードが無効です',
      requestLimit: 'リクエスト制限を超えました。後でもう一度お試しください。',
    },
  },
  memberRequestPage: {
    title: 'メンバーリクエストの確認',
    subTitle: 'リクエスト元：',
    deny: '拒否',
    approve: '承認',
    teamFull: 'チームが満員です',
    yourTeamIsFull: 'あなたのチームは満員です。追加メンバーを取得するにはお問い合わせください。',
    manageMembers: 'AdEffでメンバーを管理',
    requestApproved: 'リクエストが承認されました',
    approvedDesc:
      'あなたは <tmp>{{name}}</tmp> があなたのチームに参加することを承認しました。通知メールが自動的に送信されました。',
    requestDeclined: 'リクエストが拒否されました',
    declinedDesc:
      'あなたは <tmp>{{name}}</tmp> があなたのチームに参加することを拒否しました。通知メールが自動的に送信されました。',
  },
  infoBindPage: {
    title: 'AI駆動の広告テスト',
    desc: '超グラフマルチモーダル大規模言語モデル（HMLLM）*に基づき、クリエイティブの効果を迅速に予測し、広告ROIを向上させます',
    joinAdEff: 'AdEffに登録して新しい旅を始めましょう',
    advantages: {
      title1: 'より高性能',
      desc1: '膨大なデータベースに基づく独自のAIモデル',
      title2: 'より低コスト',
      desc2: '従来手法のわずか10%のコスト',
      title3: 'よりスピーディ',
      desc3: '最短15分でレポートを取得',
      title4: 'よりプロフェッショナル',
      desc4: '24時間365日のサポートと専門家チームサービスをご利用いただけます',
    },
    username: 'ユーザー名',
    company: '会社名',
    placeOfResidence: '国/地域',
    invitationCode: '紹介コード',
    createAccountForFree: '無料でアカウントを作成',
    refreshStatus: 'ステータスを更新',
    reapply: '再申請',
    bySigningUp: '登録により、以下に同意したものとみなします：',
    termsOfService: 'サービス利用規約',
    and: 'と',
    privacyPolicy: 'プライバシーポリシー',
    message: {
      success: 'アカウント作成リクエストが送信されました。しばらくお待ちください！',
      success2: 'アカウントが正常に作成されました',
      error: 'アカウント作成に失敗しました。後でもう一度お試しください。',
      accountCreatedDirectly: 'アカウントが直接作成されました！',
      theRequestHasBeenApprovedAndIsJumpingThePageForYou:
        'リクエストが承認され、ページが自動的にジャンプします。',
      theRequestHasBeenSendAndPleaseBePatient:
        'リクエストが送信されました。しばらくお待ちください！',
      wrongRouting: 'ルーティングエラー、ページが自動的にジャンプします。',
      yourRequestHasBeenDeclined:
        'あなたのリクエストは拒否されました。チームに再申請するか、招待コードなしで新しいアカウントを作成してください。',
      waitingForAdministratorReview: '管理者のレビューを待っています',
      thisFieldIsRequired: 'このフィールドは必須です',
      pleaseEnterTheResidence: '国名を入力してください',
      invitationCodeDoesNotExist: '無効な紹介コードです',
      ifYourCompanyHaveBeenJoinedPleaseWriteHere:
        '代理店経由でご利用の場合、紹介コードを入力してください',
      pleaseEnterTheUsername: 'ユーザー名を入力してください',
      pleaseEnterTheCompanyName: '会社名を入力してください',
      needRegisterAgain: '操作エラー、再登録してください',
      alreadyBind: 'すでに会社にバインドされています、再バインドしないでください',
    },
  },
  knowledgeFormPage: {
    name: 'お名前',
    email: 'メールアドレス',
    companyName: '会社名',
    department: '部署',
    role: '役職',
    country: '国',
    province: '都道府県',
    pleaseEnter: '入力してください',
    pleaseSelect: '選択してください',
    pleaseEnterTheName: 'お名前を入力してください',
    pleaseEnterTheEmail: 'メールアドレスを入力してください',
    pleaseEnterValidEmail: '有効なメールアドレスを入力してください',
    pleaseEnterTheCompanyName: '会社名を入力してください',
    pleaseSelectTheDepartment: '部署をお選びください',
    pleaseSelectTheRole: '役職を選択してください',
    pleaseSelectTheCountry: '国を選択してください',
    pleaseSelectTheProvince: '都道府県を選択してください',
    textIsRequired: 'この項目は必須です',
    submit: '送信',
    download: 'ダウンロード',
    submitSuccess: '送信成功',
    downloadSuccess: 'ダウンロード成功',
    title1: '情報を入力してリソースを取得してください',
    title2: 'ダウンロードしたいリソースを選択してください',
  },
  dashboard: {
    pdf: {
      downloadReport: 'レポートをダウンロード',
      downloadBtnText: 'PDF ダウンロード',
      content: '内容',
      theEnd: '',
      thankYouForWatching: 'ご清覧ありがとうございました',
      pdfProcessing: 'PDF 処理中...',
      pdfProcessingDesc: 'PDF ページ数：{{count}}，予想 {{seconds}} 秒，保存後、お待ちください',
      pdfProcessingDesc2: '現在の言語バージョンが翻訳されていないため、PDF を生成できません',
    },
    ppt: {
      downloadBtnText: 'PPTダウンロード',
      pptProcessingDesc: 'PPTファイルを生成しています。しばらくお待ちください',
      pptProcessingDesc2: '現在の言語バージョンは翻訳されていません、PPTを生成できません',
      pptProcessingDesc3: 'PPTファイルをダウンロードしています。しばらくお待ちください',
      translateCompleted: 'PPTの翻訳が完了しました',
      exportSuccess: 'PPTファイルのエクスポートが完了しました',
      exportFailed: 'PPTファイルのエクスポートに失敗しました',
    },
    layout: {
      projectMenuText: '広告テストプロジェクト',
      accountManagementText: 'アカウント管理',
      myAccountText: 'マイアカウント',
      subscriptionText: 'サブスクリプション',
      logout: 'ログアウト',
      dataDetails: 'データ詳細',
      dataAnalysis: 'データ分析',
      dataOverview: 'データ概要',
      dataComparison: 'データ比較',
    },
    systemMessage: {
      title: 'システムメッセージ',
      task: 'タスク',
      system: 'システム',
      noRelevantContent: '該当するコンテンツが見つかりません',
      noMore: 'これ以上のメッセージはありません',
    },
    projectPage: {
      createProject: 'プロジェクトを作成',
      searchPlaceholder: 'プロジェクト名/広告名/ブランド名で検索',
      sortLabel: '広告効果指数の並び替え',
      sortPlaceholder: '並び替え方法を選択してください',
      sortOption1: '効果指数の昇順',
      sortOption2: '効果指数の降順',
      filterSort: 'フィルターと並べ替え',
      filterBenchmarkTitle: 'ベンチマーク値でフィルター',
      sortTitle: '並べ替え',
      tabAllCreative: 'すべてのクリエイティブ（{{count}}）',
      tabGeneralCreative: '通常クリエイティブ（{{count}}）',
      tabSplashCreative: 'オープンスクリーンクリエイティブ（{{count}}）',
      generalCreativeLabel: '通常クリエイティブ',
      splashCreativeLabel: 'オープンスクリーンクリエイティブ',
      normTypePlaceholder: '基準値タイプを選択してください',
      totalDesc: '広告プロジェクト（全{{total}}件）',
      noRelevantContent: '該当するコンテンツが見つかりません',
      loadMore: 'さらに読み込む',
      projectCard: { delete: '削除', reanalyze: '再分析', download: 'ダウンロード' },
      delete: '削除',
      cancel: 'キャンセル',
      message: {
        deleteTitle: '削除の通知',
        delete:
          'このプロジェクトを削除すると、すべての関連データにアクセスできなくなります。続行してもよろしいですか？',
        delete1:
          'このプロジェクトは無料のテストプロジェクトです。削除すると、無料のテストの機会は返ってきません。',
        delete2:
          'このプロジェクトはまだ分析を開始していません。削除後、テストクレジットは返金されます',
        deleteSuccess: '削除成功！',
        analysisCountNotEnough:
          '分析回数が不足しています。再度チャージしてから再試行してください。',
        analysisFailed: '分析に失敗しました。後でもう一度お試しください。',
        waitingQuestion:
          '最大3つのプロジェクトを同時に分析できます。このプロジェクトは待機キューに入り、しばらくして自動的に分析を開始します。',
        landscapeQuickCompleted: '横画面-クイックテストプロジェクトが完了しました',
        portraitQuickCompleted: '縦画面-クイックテストプロジェクトが完了しました',
        landscapeSurveyCompleted: '横画面-ディープインサイトプロジェクトが完了しました',
        portraitSurveyCompleted: '縦画面-ディープインサイトプロジェクトが完了しました',
      },
    },
    projectCreatePage: {
      createProject: 'プロジェクトを作成',
      basicInformation: '基本情報',
      projectType: 'プロジェクト種別',
      projectName: 'プロジェクト名',
      categoryType: '業種',
      brandName: 'ブランド名',
      advertisingInformation: '広告情報',
      adName: '広告名',
      norm: 'ベンチマーク値',
      targetMarketNorm: 'ターゲット市場ベンチマーク値',
      brandNorm: 'ブランドベンチマーク値',
      taGender: 'TA 性別',
      targetMarket: 'ターゲット市場',
      taAge: 'TA 年齢',
      next: '次へ',
      previous: '前へ',
      confirmOrder: '注文を確定',
      estTime: '推定所要時間',
      minutes: '分',
      consumption: '今回の注文で消費',
      testPoint: 'テスト回分',
      remaining: '残り',
      times: '回',
      type: '種別',
      purchase: '購入',
      outputLanguage: '出力言語',
      durationCategory: 'クリエイティブタイプ',
      durationCategoryDesc: '分析指標はクリエイティブタイプによって異なります。コンテンツに最も適した項目を選択してください。',
      durationCategoryOptions: {
        tenPlus: '通常クリエイティブ（10秒+）',
        fiveToTen: 'オープンスクリーンクリエイティブ（5-10秒）',
      },
      adSelection: {
        adCreativeTest: '広告クリエイティブテスト',
        adCreativeTestDesc:
          '単一の広告クリエイティブのオーディエンスフィードバックをテストし、分析と提案を提供',
        adCreativeSelection: '広告クリエイティブ選定',
        adCreativeSelectionDesc:
          '複数の広告クリエイティブのフィードバック効果を比較し、総合的に選択',
        adCreativeEditing: '広告クリエイティブ編集',
        adCreativeEditingDesc: 'AIが広告クリエイティブの重要な部分を自動的に生成',
        launchingSoon: '近日公開',
      },
      industryCategorySelect: {
        /**----------------------- */
        foodAndBeverageCategory: '食品・飲料',
        packagedFood: '包装食品',
        confectionery: '菓子・スイーツ',
        frozenMeals: '冷凍食品',
        fastFood: 'ファストフード',
        beverage: '飲料',
        alcohol: 'アルコール飲料',
        dairy: '乳製品',
        grainAndSeasoning: '油脂・調味料',
        beverageMixes: '粉末飲料・インスタント',
        freshProduce: '生鮮食品',
        otherFoodAndBeverage: 'その他',
        /**----------------------- */
        consumerElectronicsCategory: 'コンシューマーエレクトロニクス',
        mobilePhone: 'スマートフォン',
        computer: 'パソコン',
        smartDevice: 'スマートデバイス',
        phoneAccessories: 'スマートフォンアクセサリー',
        computerAccessories: 'パソコンアクセサリー',
        software: 'ソフトウェア',
        camera: 'カメラ',
        officeSupplies: 'オフィス用品',
        otherConsumerElectronics: 'その他',
        /**----------------------- */
        pharmaceuticalsAndHealthCareCategory: '医薬品・ヘルスケア',
        otcMedicine: 'OTC医薬品',
        prescriptionDrugs: '処方薬',
        healthSupplements: '健康補助食品',
        pharmaceuticalCompanies: '製薬企業',
        medicalDevices: '医療機器',
        medicalServices: '医療サービス',
        pharmacy: '薬局',
        otherPharmaceuticalsAndHealthCare: 'その他',
        /**----------------------- */
        beautyAndPersonalCareCategory: 'ビューティー・パーソナルケア・洗剤',
        hairCare: 'ヘアケア',
        womenSkincare: '女性スキンケア',
        homeCleaning: '家庭用洗剤',
        bodyCare: 'ボディケア',
        feminineCare: 'フェミニンケア',
        oralCare: 'オーラルケア',
        menSkincare: 'メンズスキンケア',
        makeup: 'メイクアップ',
        fragrances: 'フレグランス',
        beautyServices: 'ビューティーサービス',
        otherBeautyAndPersonalCare: 'その他',
        /**----------------------- */
        maternalAndInfantProductsCategory: 'マタニティ・ベビー用品',
        babyFood: 'ベビーフード',
        babyCareEssentials: 'ベビーケア用品',
        babyToys: 'ベビー玩具',
        otherMaternalAndInfantProducts: 'その他',
        /**----------------------- */
        networkAndCommunicationCategory: 'ネットワーク・通信',
        mobileCarriers: 'モバイル通信キャリア',
        internetProviders: 'インターネットプロバイダー',
        telecomEquipment: '通信機器',
        otherNetworkAndCommunication: 'その他',
        /**----------------------- */
        travelAndAccommodationCategory: 'トラベル・宿泊',
        localTourism: '観光・地域',
        bookingPlatform: '予約プラットフォーム',
        hotels: 'ホテル',
        airlines: '航空会社',
        airport: '空港',
        otherTravelAndAccommodation: 'その他',
        /**----------------------- */
        vehiclesCategory: '交通',
        motorVehicleProductsAndServices: '自動車製品・サービス',
        carBrands: '自動車ブランド',
        dealerships: '自動車ディーラー',
        carFinance: '自動車金融',
        evCar: '電気自動車',
        motorcycle: 'バイク',
        onlineUsedCarMarketplace: '中古車オンライン取引プラットフォーム',
        carRentalPlatform: 'レンタカープラットフォーム',
        travelNavigation: 'ナビゲーション',
        bicycle: '自転車',
        otherVehicles: 'その他',
        /**----------------------- */
        householdAppliancesCategory: '家電製品',
        majorAppliances: '大型家電',
        healthAndPersonalCareAppliances: '健康・パーソナルケア',
        majorKitchenAndBathAppliances: 'キッチン・バス大型家電',
        smallKitchenAppliances: '小型キッチン家電',
        environmentalAppliances: '環境家電',
        cleaningAppliances: '掃除家電',
        otherHouseholdAppliances: 'その他家電',
        /**----------------------- */
        retailAndServiceCategory: 'リテール・サービス',
        onlineRetailEcommerce: 'オンラインリテール・EC',
        departmentStores: '百貨店',
        lifeServices: '生活サービス',
        retailServicesAndDelivery: 'リテールサービス・デリバリ',
        supermarkets: 'スーパーマーケット',
        otherRetailAndService: 'その他',
        /**----------------------- */
        apparelCategory: 'アパレル・アクセサリ',
        footwear: '靴',
        clothing: '服装',
        watchesWatchRetail: '腕時計・時計店',
        jewelry: 'ジュエリー',
        bags: 'バッグ・鞄',
        eyewearOpticalStores: 'メガね・眼鏡店',
        otherClothingAndAccessories: 'その他',
        /**----------------------- */
        homeImprovementAndFurnishingsCategory: 'インテリア',
        homeFurnishing: 'ホーム',
        homeImprovement: 'インテリが',
        otherHomeImprovementAndFurnishings: 'その他',
        /**----------------------- */
        financialAndInsuranceCategory: '金融・資産運用・保険',
        bank: '銀行',
        fintech: 'ファインテック',
        investmentAndFinancialServices: '金融・資産運用',
        insurance: '保険',
        otherFinancialAndInsurance: 'その他',
        /**----------------------- */
        entertainmentAndLeisureCategory: 'レジャー・エンタメ',
        socialApp: 'SNS APP',
        toysAndDolls: '玩具・人形',
        concerts: 'コンサート',
        events: 'スポーツイベント',
        movies: '映画',
        themeParks: 'テーマパーク',
        gambling: 'ギャンブル',
        onlineGaming: 'オンラインゲーム',
        tvChannels: 'テレビチャンネル',
        otherEntertainmentAndLeisure: 'その他',
        /**----------------------- */
        industrialAndAgriculturalCategory: '工業・農業',
        industrialSupplies: '工業用品',
        agriculturalSupplies: '農業用品',
        otherIndustrialAndAgricultural: 'その他',
        /**----------------------- */
        petLifeCategory: 'ペット',
        petFood: 'ペットフード',
        petSupplies: 'ペット用品',
        otherPetLife: 'その他',
        /**----------------------- */
        educationAndLearningCategory: '教育・学習',
        onlineLearning: 'オンライン教育',
        schools: '学校',
        skillCourses: 'スキルアップコース',
        tutoring: '学習塾',
        universities: '大学',
        otherEducationAndLearning: 'その他',
        /**----------------------- */
        communityAndPublicServiceCategory: 'コミュニティ・公共サービス',
        charityCampaigns: 'チャリティーキャンペーン',
        ngoAds: 'NGO広告',
        otherCommunityAndPublicService: 'その他',
        /**----------------------- */
        otherCategory: 'その他',
        governmentAdvertising: '政府広告',
        realEstateAdvertising: '不動産広告',
        otherAdvertising: 'その他',
      },
      genderSelect: {
        male: '男性',
        female: '女性',
        all: 'すべて',
      },
      targetMarketSelect: {
        China: '中国',
        HongKongChina: '香港（中国）',
        MacauChina: 'マカオ（中国）',
        TaiwanChina: '台湾（中国）',
        Japan: '日本',
        Korea: '韓国',
        Mongolia: 'モンゴル',
        Singapore: 'シンガポール',
        Thailand: 'タイ',
        Vietnam: 'ベトナム',
        Malaysia: 'マレーシア',
        Philippines: 'フィリピン',
        Indonesia: 'インドネシア',
        Cambodia: 'カンボジア',
        Laos: 'ラオス',
        India: 'インド',
        SaudiArabia: 'サウジアラビア',
        Turkey: 'トルコ',
        Israel: 'イスラエル',
        UnitedArabEmirates: 'アラブ首長国連邦',
        Qatar: 'カタール',
        Kuwait: 'クウェート',
        UnitedKingdom: 'イギリス',
        France: 'フランス',
        Germany: 'ドイツ',
        Netherlands: 'オランダ',
        Belgium: 'ベルギー',
        Austria: 'オーストリア',
        Italy: 'イタリア',
        Spain: 'スペイン',
        Portugal: 'ポルトガル',
        Greece: 'ギリシャ',
        Sweden: 'スウェーデン',
        Norway: 'ノルウェー',
        Finland: 'フィンランド',
        Denmark: 'デンマーク',
        Estonia: 'エストニア',
        Latvia: 'ラトビア',
        Russia: 'ロシア',
        Poland: 'ポーランド',
        CzechRepublic: 'チェコ共和国',
        Hungary: 'ハンガリー',
        Romania: 'ルーマニア',
        Bulgaria: 'ブルガリア',
        Slovakia: 'スロバキア',
        Slovenia: 'スロベニア',
        Ukraine: 'ウクライナ',
        UnitedStates: 'アメリカ合衆国',
        Canada: 'カナダ',
        Mexico: 'メキシコ',
        Brazil: 'ブラジル',
        LatinAmerica: 'ラテンアメリカ',
        Australia: 'オーストラリア',
        NewZealand: 'ニュージーランド',
        Other: 'その他',
      },
      languageSelect: {
        english: '英語',
        chinese: '中国語',
        japanese: '日本語',
        korean: '韓国語',
        french: 'フランス語',
        traditionalChinese: '繁体字中国語',
      },
      placeholder: {
        projectName: 'プロジェクト名を入力してください',
        category: 'カテゴリを選択してください',
        brandName: 'ブランド名を入力してください',
        adName: '広告名を入力してください',
        norm: 'ベンチマーク値を選択してください',
        taGender: '性別を選択してください',
        targetMarket: 'ターゲット市場を選択してください',
        taAge: '年齢を選択してください',
        lowerLimit: '下限',
        upperLimit: '上限',
        outputLanguage: '出力言語を選択してください',
      },
      step: {
        step1: 'プロジェクト情報の入力',
        step2: '注文情報の確認',
      },
      message: {
        success: '作成成功',
        videoDurationOver60s: '動画の長さが{{max}}秒を超えています',
        videoDurationLessThan10s: '動画の長さが{{min}}秒未満です',
        videoDurationNeedOver10s: '動画の長さは10秒を超える必要があります',
        videoDurationNeedWithin5To10s: '動画の長さは5秒から10秒の範囲である必要があります',
        videoDurationNotMatchDurationCategory: '現在の動画の長さはこのプロジェクトタイプの要件を満たしていません。動画を再アップロードして再試行してください。',
        videoUploadingCannotSwitchDurationCategory: '動画のアップロード中はクリエイティブタイプを切り替えられません。アップロード完了までお待ちください。',
        videoFormatOrDurationError: '動画の形式または長さを読み取れません。動画ファイルを確認して再試行してください。',
        videoSizeOver200M: '動画のサイズが256MBを超えています',
        videoLandscape: '動画は横画面である必要があります',
        videoPortrait: '動画は縦向きである必要があります',
        clickToUploadTestVideo: 'クリックしてテスト動画をアップロード',
        uploadFailed: 'アップロードに失敗しました。再度アップロードしてください',
        uploadDesc1: '対応フォーマット：横画面サイズ、MP4 / MOV形式',
        uploadDescPortrait: '対応フォーマット：縦画面サイズ、MP4 / MOV形式',
        uploadDesc2: 'ファイルサイズ上限：256MB',
        formNotCompleted: 'すべての情報を入力してください',
        uploadAdVideo: '広告動画をアップロードしてください',
        inputInvalid: '入力内容が無効です',
        insufficientTestPoints: 'テスト回数が不足しています。チャージしてから再試行してください。',
        reviewProjectInfo:
          'プロジェクト情報をよくご確認ください。注文確定後の変更はできません。',
        waitingDesc:
          '同時分析は最大3プロジェクトまでです。上限を超えたプロジェクトは待機キューに入り、順次分析されます。',
        ageRangeInvalid: '年齢範囲は20-55のみサポートされています',
        normDesc: '無制限の著作権特典、企業が独自の基準値を設定できます',
      },
    },
    projectDetailPage: {
      testResults: 'テスト結果',
      share: '共有',
      shareFailed: '共有に失敗しました',
      shareModal: {
        title: '共有',
        desc: '以下のテキストをコピーして、SNSで共有してください。',
        saveImage: '画像を保存',
        copyText: 'テキストをコピー',
        copySuccess: 'コピーしました',
        copyFailed: 'コピーに失敗しました',
        textTemplate:
          'すごい！私のAIクリエイティブはAdEffで同種クリエイティブの{{score}}%を上回りました！やはりデータが実力です。AdEffのAIクリエイティブテストは今なら無料。{{hostname}}でスコアをチェックしましょう。無料テストを5回獲得して、すばらしい評価を目指してください！',
      },
      sharePoster: {
        createdByYou: 'あなたが創作した作品',
        scoreTemplate: '<score>{{score}}</score>のAIGCクリエイティブを上回りました',
        statsAt: '集計時刻 ',
        certification: 'クリエイティブ認証',
        footerText: 'これからも創作を続け、より多くの優れた作品を生み出してください！',
      },
      basicInformation: '基本情報',
      waiting: '待機中',
      ongoing: '実行中',
      failed: '失敗',
      tryAgain: '再試行',
      videoAnalysisFailed: '動画分析に失敗しました',
      message: { projectNotFound: 'プロジェクトが見つかりません' },
      primaryAnalysis: '主要パフォーマンス',
      detailAnalysis: 'モーメント分析',
      heatmapAnalysis: 'ヒートマップ',
      analysisStepDesc: 'AIによるすべての分析が完了しました。詳細は以下の通りです。',
      analysisWaitingDesc:
        '最大3つのプロジェクトを同時に分析できます。このプロジェクトは待機キューに入り、しばらくして自動的に分析を開始します。',
      aiTip: '本レポートの内容はすべてAIによって生成されています。参考情報としてご確認ください',
      subAnalysisDescription: {
        adVideoScore: '広告効果指数',
        adVideoScoreDesc:
          '広告効果指数は、広告の有効性を測る総合指標であり、広告がもたらす短期的および長期的な販売効果を予測することができます。',
        norm: 'ベンチマーク値',
        normDesc: '業界または過去データに基づくベンチマーク値です。広告パフォーマンスの横断的な比較にご活用いただけます。',
        attentionIndex: '注意指数',
        attentionIndexDesc:
          '注意指数は、オーディエンスの視覚的注意力の集中状況を表し、広告画面におけるストーリー展開や要素が視聴者の関心を引きつける能力を反映します。',
        emotionIndex: '感情指数',
        emotionIndexDesc:
          '感情指数は、オーディエンスのポジティブな感情が喚起された度合いを示し、広告によって引き起こされる即時的な感情の揺れを反映します。',
        cognitionIndex: '認知指数',
        cognitionIndexDesc:
          '認知指数は、オーディエンスの認知的処理の度合いを反映し、広告の内容に対してどの程度思考が行われたかを示します。',
        theGolden3Seconds: '冒頭3秒',
        theGolden3SecondsDesc: '広告の冒頭3秒は、その成否を左右する重要な瞬間です。',
        informationTransmission: '情報モーメント',
        informationTransmissionDesc:
          '広告メッセージがターゲットの関心を引きつけ、興味を惹く効果を測定します。',
        brandRelevance: 'ブランド・モーメント',
        brandRelevanceDesc:
          'ブランドメッセージがターゲットの関心を引きつけ、興味を惹く効果を測定します。',
        interestStimulation: '興味モーメント',
        interestStimulationDesc:
          '視聴者の共感と主体的な認知を促す重要なコンテンツの瞬間です。',
        theEnding3Seconds: '末尾3秒',
        theEnding3SecondsDesc:
          'ピーク・エンドの法則に基づき、広告の最後3秒は視聴者の関心を定着させ、メッセージの伝達を強化する重要な瞬間です。',
      },
      infoDrawer: {
        basicInformation: '基本情報',
        advertisingInformation: '広告情報',
        projectName: 'プロジェクト名',
        brandName: 'ブランド名',
        category: '業種',
        norm: 'ターゲット市場ベンチマーク値',
        normLabel: 'ベンチマーク値',
        brandNorm: 'ブランドベンチマーク値',
        adName: '広告名',
        taGender: 'TA 性別',
        targetMarket: 'ターゲット市場',
        taAge: 'TA 年齢',
        ageRange: '{{start}} から {{end}} 歳',
        modify: '変更',
        cancel: 'キャンセル',
        confirm: '確認',
      },
      videoView: {
        eyeMovementRatio: '注意指数',
        cognitiveEngagement: '認知指数',
        emotionRecognition: '感情指数',
        subjectiveResponseCurve: '主観的反応曲線',
        realtimeData: 'リアルタイムデータ',
        panoramicData: '全体データ',
        indexAnalysis: '指標分析',
        advantage: '強み',
        disadvantage: '弱み',
        suggestions: '改善案',
        adVideoScore: '広告効果指数',
        norm: 'ベンチマーク値',
        analysisStepTitle1: 'コンテンツデコード',
        analysisStepTitle2: 'フィードバック予測',
        analysisStepTitle3: 'データ統合',
        analysisStepTitle4: '結論推論',
        analysisStepDesc1:
          '広告コンテンツのマルチモーダル解析を開始します（視覚、音声、テキスト、構造を解析中...）',
        analysisStepDesc2:
          '視聴者の主観的な反応を予測します。広告の秒単位のコンテンツに基づき、視線の動きや脳波データを予測しています…',
        analysisStepDesc3: '広告の客観的なコンテンツと視聴者の主観的な反応データを統合しています…',
        analysisStepDesc4: '推論モデルに基づき、評価結果とアクションプランを生成しています…',
        keyResult: '主要結果',
        videoChart: {
          videoFailed: '動画再生に失敗しました',
          videoFailedAction:
            '更新して再試行してください。複数の更新後も問題が続く場合は、サポートにお問い合わせください。',
        },
      },
      storyboardView: {
        summary: '要約',
        advantages: '強み',
        disadvantages: '弱み',
        suggestions: '改善案',
        keyResult: '主要結果',
        norm: 'ベンチマーク値',
        theGolden3Seconds: '冒頭3秒',
        informationTransmission: '情報モーメント',
        brandRelevance: 'ブランド・モーメント',
        interestStimulation: '興味モーメント',
        theEnding3Seconds: '末尾3秒',
      },
      heatmapView: {},
    },
    accountPage: {
      email: 'メールアドレス',
      username: 'ユーザー名',
      password: 'パスワード',
      setPasswordToEnableEmailLogin: 'メールログインを有効にするためにパスワードを設定',
      uid: 'UID',
      contactAndReceiveNotifications: '連絡先と通知設定',
      receiveEmailsAboutAdeffLatestUpdatesWithThisEmail:
        'AdEffの最新情報をこのメールアドレスで受け取ります。',
      myWorkspace: '私のワークスペース',
      newRequest: '新しいリクエスト',
      invitationCode: '紹介コード',
      userName: 'ユーザー名',
      invitationCodeDesc:
        '各チームには、新しいユーザーが登録中にチームに参加するための独自の招待コードがあります',
      table: {
        userName: 'ユーザー名',
        email: 'メールアドレス',
        operation: '操作',
        admin: '管理者',
        remove: '削除',
        deny: '拒否',
        approve: '承認',
      },
      message: {
        yourTeamIsFull:
          'あなたのチームは満員です。追加メンバーを取得するにはお問い合わせください。',
        invitationLinkSent: '招待リンクがこのメールアドレスに送信されました！',
        removeReminder: '削除の通知',
        remove: '削除',
        removeMember:
          'メンバーを削除すると、そのメンバーが作成したコンテンツは保持されます。メンバーを削除してもよろしいですか？',
        removeMemberSuccess: 'メンバーの削除に成功しました！',
        ok: 'OK',
        contactUs: 'お問い合わせ',
        applicationProcessedSuccessfully: '申請が正常に処理されました！',
        notificationSettingsTurnedOn: '通知設定がオンになりました',
        notificationSettingsTurnedOff: '通知設定がオフになりました',
        setPassword: 'パスワードを設定',
        passwordConfirm: '確認',
        passwordCancel: 'キャンセル',
        oldPassword: '現在のパスワード',
        newPassword: '新しいパスワード',
        pleaseEnterTheOldPassword: '現在のパスワードを入力してください',
        pleaseEnterTheNewPassword: '新しいパスワードを入力してください',
        incorrectEntryOfOriginalPassword: '元のパスワードの入力が間違っています',
        passwordUpdatedSuccessfully: 'パスワードが正常に更新されました',
        changeUsername: 'ユーザー名を変更',
        confirm: '確認',
        cancel: 'キャンセル',
        username: 'ユーザー名',
        pleaseEnterTheNewUsername: '新しいユーザー名を入力してください',
        userNameUpdatedSuccessfully: 'ユーザー名が正常に更新されました',
        addMemberToWorkspace: 'ワークスペースに新しいメンバーを追加',
        notAdminOperate: '管理者ではないため、操作できません',
        emailAddress: 'メールアドレス',
        send: '送信',
        willSendAnInvitationEmailToThisAddressForConfirmation:
          'このアドレスに確認のための招待メールを送信します。',
        workspaceMemberShip: 'ワークスペースメンバーシップ',
        forMoreMembership: 'より多くのメンバーシップ',
        reachedTheCeiling: '人数が上限に達しました。',
        incorrectMailboxFormat: 'メールボックスの形式が正しくありません',
        member: 'メンバー',
        changeCorpNameTitle: '会社名を変更',
        changeCorpNameLabel: '会社名',
        pleaseEnterTheCorpName: '会社名を入力してください',
        changeCorpNameSuccess: '会社名が正常に変更されました',
        changeCorpNameFailed: '会社名の変更に失敗しました',
        noPermission: '会社名の変更権限がありません',
      },
    },
    subscriptionPage: {
      currentPlan: '現在のプラン',
      getInvoice: '請求書を取得',
      remainingTimes: '残り回数',
      purchaseMore: '追加購入',
      contactUs: 'お問い合わせ',
      teamPlan: '専門家チームサービス',
      unlimited: 'アンリミテッドプラン',
      dueDate: '有効期限',
      table: {
        usageRecords: '利用履歴',
        date: '日付',
        projectName: 'プロジェクト名',
        projectType: 'プロジェクト種別',
        usageCount: '回数',
        userName: 'ユーザー名',
        noRelevantContent: '該当するコンテンツが見つかりません',
      },
    },
    portraitDataDetailPage: {
      regularCreativeProject: '通常クリエイティブプロジェクト',
      regularCreative: '通常クリエイティブ',
      splashCreativeProject: 'オープンスクリーンクリエイティブプロジェクト',
      splashCreative: 'オープンスクリーンクリエイティブ',
      projects: 'プロジェクト数',
      localNorm: 'ベンチマーク値',
      projectPassRate: 'プロジェクト通過率',
      passRate: '通過率',
    },
    dataDetailPage: {
      baseData: '基本データ',
      totalProjects: '総プロジェクト数',
      totalProjectsDesc: '広告効果評価に参加した有効な案件の総数。',
      // averageEffectivenessIndex: '平均広告効果指数',
      // averageEffectivenessIndexDesc: 'すべての有効なプロジェクトの広告効果指数の平均値。',
      localNormProjects: 'ローカル基準値プロジェクト',
      brandNormProjects: 'ブランド基準値プロジェクト',
      normProject: 'ターゲット市場基準値プロジェクト',
      brandNormProject: 'ブランド基準値プロジェクト',
      localNorm: 'ベンチマーク値',
      localNormDesc:
        '貴国をターゲット市場とした有効な広告案件における、広告効果指数（AEI）の平均スコア。',
      norm: 'ベンチマーク値',
      brandNorm: 'ブランドベンチマーク値',
      brandNormDesc:
        'あなたが独自に設定したブランド基準値を使用した有効な広告プロジェクトの広告効果指数の平均値。',
      localProjectPassRate: 'ローカルプロジェクト合格率',
      projectPassRate: 'プロジェクト合格率',
      brandProjectPassRate: 'ブランドプロジェクト合格率',
      projectPassRateDesc: '広告効果指数のスコアが基準値を上回る案件数の、全評価案件数に占める割合。',
      advertisingEffectivenessIndexDistribution: '広告効果指数分布',
      advertisingEffectivenessIndexDistributionDesc: '広告効果指数のスコア帯ごとの案件比率',
      item: '項目',
    },
    dataComparisonPage: {
      createCompare: '新規比較を作成',
      createCompareDesc: '複数プロジェクトを選択して比較できます（最大10件）。',
      startCompare: '比較を開始',
      compareReport: '比較レポート',
      searchPlaceholder: '比較レポート名で検索',
      emptyText: '現在、比較レポートはありません。プロジェクトを選択して比較を開始してください。',
      searchEmptyText: '比較レポートが見つかりません。',
      deleteTitle: '比較レポートを削除',
      deleteConfirm: 'この比較レポートを削除してもよろしいですか？この操作は元に戻せません。',
      projectCount: '{{count}} 件のプロジェクト',
    },
    dataComparisonStartPage: {
      back: '戻る',
      basicInfo: '基本情報',
      reportName: 'レポート名:',
      reportNamePlaceholder: '比較レポート名を入力してください',
      norm: 'ベンチマーク:',
      normPlaceholder: 'ベンチマーク値を選択してください',
      normTip: 'プロジェクト比較時に使用するベンチマーク値を選択してください',
      selectProject: 'プロジェクトを選択',
      searchPlaceholder: 'プロジェクト名/広告名/ブランド名で検索',
      selectedCountPrefix: ' 選択済み ',
      selectedCountSuffix: ' 件、最大{{max}}件まで',
      startCompare: '比較を開始',
      save: '保存',
      cancel: 'キャンセル',
      maxSelectedWarning: '最大10件のプロジェクトを選択できます',
      reportNameRequired: '比較レポート名を入力してください',
      normRequired: 'ベンチマーク値を選択してください',
      projectRequired: 'プロジェクトを選択してください',
    },
    dataComparisonInfoPage: {
      defaultReportName: '比較レポート名',
      reportNotFound: 'レポートが見つかりません',
      back: '戻る',
      modify: '編集',
      deletedProjectTip: '次のプロジェクト：{{names}} は削除されました。確認後、比較レポートを更新し、削除済みプロジェクトを除外します。',
      confirmDeletedProjects: '確認',
      metricScore: '指標スコア',
      tabDimension: '5つの次元',
      tabMoment: 'キーモーメント',
      tabAttitude: '消費者態度',
      adeffScore: 'AdEffスコア',
      brandName: 'ブランド名',
      projectName: 'プロジェクト名',
      industry: '業種',
      targetMarket: 'ターゲット市場',
      gender: 'TA性別',
      age: 'TA年齢',
      adProject: '広告プロジェクト',
      normLabel: 'ベンチマーク値',
      mixedCreativeBenchmarkTip: '通常クリエイティブとオープンスクリーンクリエイティブを同時に比較する場合、ベンチマークは適用されません',
      emptyProject: '比較データを表示するにはプロジェクトを選択してください',
      viewProjectDetail: 'プロジェクト詳細を表示',
      listSeparator: '、',
      metricLabels: {
        attention: '注意力',
        infectivity: '感染力',
        delivery: '伝達力',
        brand: 'ブランド力',
        persuasion: '説得力',
        gazeRecognition: '注視認識',
        emotionRecognition: '感情認識',
        engagementRecognition: '没入度認識',
        goldenSeconds: '冒頭3秒',
        brandMoment: 'ブランド・モーメント',
        productMoment: '興味モーメント',
        messageMoment: '情報モーメント',
        endingSeconds: '末尾3秒',
        likeability: '好意度',
        newInformation: '新規情報',
        messageRelevance: '関連性',
        comprehension: '理解度',
        credibility: '信頼性',
        brandLinkage: 'ブランド適合度',
        uniqueness: '独自性',
        learnMoreIntent: '理解意欲',
        purchaseIntent: '購買意欲',
        recommendIntent: '共有意欲',
        brandLikeabilityLift: 'ブランド好意度向上',
        purchaseIntentionLift: '購買意欲向上',
        attentionIndex: '注意指数',
        emotionIndex: '感情指数',
        cognitionIndex: '認知指数',
      },
    },
    experience: {
      projectDetailPage: {
        analysisCompleted: '横画面-ディープインサイトプロジェクトが完了しました。',
        title: {
          text1: '広告クリエイティブテスト',
          text2: 'テストレポート',
        },
        flowAnalysis: {
          desc1: 'AdEffが動画広告を分解しています',
          desc2: '動画の解析が完了しました',
          desc3: '消費者の視覚的注意を分析中です',
          desc4: '消費者プロファイルに基づき、注目ポイントを分析しています',
          desc5: 'ヒートマップを生成中です',
          desc6: '動的ヒートマップが生成されました',
          desc7: '認知神経反応を測定中です',
          desc8: '消費者の視線・感情・エンゲージメント反応を1秒単位で分析中です',
          desc9: '認知神経曲線を生成中です',
          desc10: '認知神経曲線が生成されました',
          desc11: '広告のキーモーメントのパフォーマンスを分析中です',
          desc12: '冒頭3秒・情報モーメント・ブランドモーメント・興味モーメント・末尾3秒の認知神経反応を測定しています',
          desc13: 'キーモーメント指標を統合中です',
          desc14: 'キーモーメント分析が完了しました',
          desc15: '消費者態度を分析中です',
          desc16: 'ブランド・製品・コンテンツに対する消費者の態度傾向を分析中です',
          desc17: '態度指標を統合中です',
          desc18: '態度指標の分析が完了しました',
          desc19: '5つの主要ディメンション指標を生成しています',
          desc20: '5つの主要ディメンション指標の生成が完了しました',
          desc21: 'すべての分析が完了しました。広告のパフォーマンスを確認しましょう！',
          terminology: {
            thumbExpand: 'サムネイルを展開',
            thumbCollapse: 'サムネイルを閉じる',
            gazeRecognition: '注視認識',
            gazeRecognitionDesc: '消費者の視覚的注意力の集中度合い。広告画面内のプロットや要素が、視聴者をどれだけ惹きつけるかを反映します。',
            emotionRecognition: '感情認識',
            emotionRecognitionDesc: '消費者のポジティブ感情が喚起された度合い。広告によって引き起こされた即時的な情緒的反応を反映します。',
            engagementRecognition: '没入度認識',
            engagementRecognitionDesc: '消費者の没入・エンゲージメントの深さ。広告コンテンツに対してどれだけ深く思考したかを反映します。',
            theGolden3Seconds: '冒頭3秒',
            theGolden3SecondsDesc: '広告の冒頭3秒間におけるコンテンツのパフォーマンスを評価します。',
            keyMessage: '情報モーメント',
            keyMessageDesc: '広告メッセージがターゲットの関心を引きつけ、興味を惹く効果を測定します。',
            brand: 'ブランド・モーメント',
            brandDesc: 'ブランドメッセージがターゲットの関心を引きつけ、興味を惹く効果を測定します。',
            interest: '興味モーメント',
            interestDesc: '視聴者の感情的共鳴と高い没入度を引き出すキーコンテンツのパフォーマンスを評価します。',
            ending3Seconds: '末尾3秒',
            ending3SecondsDesc: '広告の末尾3秒間におけるコンテンツのパフォーマンスを評価します。',
            score: 'スコア',
            benchmark: 'ベンチマーク値',
            metrics: '指標',
            attitudePart: {
              attitudeMetrics: '態度指標',
              liking: '好意度',
              likingDesc: '視聴者の広告に対する主観的態度。全体的な好意の度合いを測定します。',
              newInformation: '新規情報',
              newInformationDesc: '視聴後に、これまで知らなかったブランドや製品に関する価値ある情報を得られたと、視聴者が主観的に感じたかどうかを測定します。',
              messageRelevance: '関連性',
              messageRelevanceDesc: '広告が伝えるメッセージが自分に直接関係すると、視聴者が主観的に認識しているかどうかを測定します。',
              comprehension: '理解度',
              comprehensionDesc: '広告の核心メッセージが、視聴者に明確かつ正確に、ストレスなく理解されているかどうかを測定します。',
              credibility: '信頼性',
              credibilityDesc: '広告が伝える情報が真実で、信頼に値すると、視聴者がどの程度信じているかを測定します。',
              brandLinkage: 'ブランド適合度',
              brandLinkageDesc: '視聴者が広告コンテンツを特定のブランドと正しく、かつ強く結びつけられるかどうかを測定します。',
              uniqueness: '独自性',
              uniquenessDesc: '広告が、競合他社との比較において、そのブランドが明確かつ価値ある独自性を持つという認識を確立できたかどうかを測定します。',
              willing: '理解意欲',
              willingDesc: '広告視聴後に、ブランドや製品についてさらに詳しく調べようと、視聴者が自発的に行動する主観的な可能性を測定します。',
              purchase: '購買意欲',
              purchaseDesc: '広告視聴後に、将来そのブランドの製品を選択・購入することを、視聴者が検討する主観的な可能性を測定します。',
              share: '共有意欲',
              shareDesc: '広告視聴後に、その広告やブランド情報を他者に自発的に共有する主観的な可能性を測定します。',
              brandLikeLift: 'ブランド好意度向上',
              brandLikeLiftDesc: '広告視聴後に、ブランドや製品に対する視聴者の好意度がどの方向に、どの程度変化したかを測定します。',
              purchaseIntentLift: '購買意欲向上',
              purchaseIntentLiftDesc: '広告視聴後に、そのブランド製品の購入検討意欲がどの方向に、どの程度変化したかを測定します。',
            },
            dimensionPart: {
              forceDrives: 'ディメンション指標',
              attension: '注意力',
              emotionalImpact: '感染力',
              messageClarity: '伝達力',
              brandPower: 'ブランド力',
              persuasion: '説得力',
              attentionForce: '注意力',
              attentionForceDesc: 'クリエイティブが消費者の視覚的・聴覚的注意をどれだけ引きつけ、持続させるかを測定します。',
              emotionalForce: '感染力',
              emotionalForceDesc: 'クリエイティブが視聴者の本能的・即時的な感情共鳴と情緒的反応をどれだけ強く喚起するかを測定します。',
              messageForce: '伝達力',
              messageForceDesc: 'クリエイティブの核心メッセージがターゲット視聴者に明確に認識され、正しく理解され、深く記憶される有効性を測定します。',
              brandForce: 'ブランド力',
              brandForceDesc: 'クリエイティブがブランド・アイデンティティを強化し、ブランド好意度を高め、強固なブランド連想を構築する効果を測定します。',
              persuasiveForce: '説得力',
              persuasiveForceDesc: 'クリエイティブがユーザーの認識を変容させ、行動意向を駆動する最終的なコンバージョン力を測定します。',
            },
            result: {
              results: '結果',
              pass: '合格',
              notPass: '不合格',
              adeffScore: 'AdEffスコア',
              adeffScoreDesc: 'AdEffスコアは広告全体の有効性を測定するための指標です。',
              benchmarkDesc: '広告が配信される国・地域において、アップロードされた全広告のAdEffスコアの平均値。当該国・地域における相対的なパフォーマンス比較に用いられます。',
            },
          },
        },
        pptAnalysis: {
          emptyState: {
            waiting: '待機中...',
            description: 'テストレポートを生成しています...',
          },
          generating: '生成中...',
          freeTrialLockText1: '試用中は完全なレポートのプレビューやダウンロードはできません。',
          freeTrialLockText2: 'サブスクリプション後にロックが解除されます。',
        },
      },
    },
  },
  professor: {
    account: 'アカウント',
    password: 'パスワード',
    login: 'ログイン',
    expertReviews: '専門家評価',
    adVideoScore: '広告効果指数',
    subjectiveResponseCurve: '主観的反応曲線',
    indexAnalysis: '指標分析',
    keyResult: '主要結果',
    theGolden3Seconds: '冒頭3秒',
    informationTransmission: '情報モーメント',
    brandRelevance: 'ブランド・モーメント',
    interestStimulation: '興味モーメント',
    theEnding3Seconds: '末尾3秒',
    heatMap: 'ヒートマップ',
    suggestion: '提案',
    suggestion1: '改善案',
    submit: '送信',
    next: '次へ',
    summary: '要約',
    advantages: '強み',
    disadvantages: '弱み',
    option1: '予想',
    option2: '予想外',
    resultJudgment: '評価',
    placeholder: '提案を入力してください',
    waitRateCount: '評価待ちの広告数',
    unfinishedTitle: '注意',
    unfinishedRate: '現在のプロジェクトに未評価のコンテンツがあります。続けますか？',
    unfinishedConfirm: '続ける',
    unfinishedCancel: 'キャンセル',
    message: {
      submitSuccess: '評価ありがとうございました',
      submitSuccess1: '現在のプロジェクトの評価を完了しました。ありがとうございました',
      loginSuccess: 'ログインに成功しました',
      rateUnfinished: '現在の内容をまだ評価していません。記入してから次の質問に進んでください。',
      rateLocation: '未評価のコンテンツに自動的に移動しました',
    },
  },
  modals: {
    freeTrialModal: {
      title: 'トライアル申込み',
      title1: '無料試用',
      trial: '試用',
      hiddenBoxText1: '複数の利点、欠点、提案が検出されました',
      hiddenBoxText2: '完全なレポートを取得するには、サブスクリプションしてください',
      hiddenBoxBtn: 'サブスクリプション',
      applyBox: {
        name: 'お名前',
        tel: '電話番号',
        department: '部署',
        role: '役割',
        country: '国',
        city: '市',
        pleaseEnter: '入力してください',
        pleaseSelect: '選択してください',
        pleaseEnterTheName: 'お名前を入力してください',
        pleaseEnterTheTel: 'ご連絡先を入力してください',
        pleaseEnterValidTel: '連絡先番号を入力してください',
        pleaseEnterValidEmail: '有効なメールアドレスを入力してください',
        pleaseSelectTheDepartment: '部署をお選びください',
        pleaseSelectTheRole: '役割を選択してください',
        pleaseSelectTheCountry: '国を選択してください',
        pleaseEnterTheCity: '市を入力してください',
        textIsRequired: 'このフィールドは必須です',
        submit: '送信',
        tip: '無料トライアルは、企業ごとに1回のみご利用いただけます。',
      },
      gotTrial: '試用版を受け取りました！',
      goPc: 'プロジェクトを作成するには、PC版のWebバージョンにアクセスしてください。',
      back: '戻る',
      country: {
        China: '中国',
        Japan: '日本',
        Korea: '韓国',
        Indonesia: 'インドネシア',
        Thailand: 'タイ',
        Singapore: 'シンガポール',
        Malaysia: 'マレーシア',
        Vietnam: 'ベトナム',
        Germany: 'ドイツ',
        Britain: 'イギリス',
        France: 'フランス',
        Italy: 'イタリア',
        Russia: 'ロシア',
        Spain: 'スペイン',
        Turkey: 'トルコ',
        America: 'アメリカ',
        Canada: 'カナダ',
        Brazil: 'ブラジル',
        Other: 'その他',
      },
      department: {
        Brand: 'ブランド部',
        Market: 'マーケティングリサーチ＆インサイト部',
        Marketing: 'マーケティング部',
        IT: 'IT/デジタル部',
        Procurement: '購買部',
        Other: 'その他',
      },
      role: {
        President: '社長/副社長/総務',
        CMO: 'CMOまたは他のCレベル管理',
        Director: '部門長',
        Manager: '部門長',
        Other: 'その他',
      },
      message: {
        submitSuccess: '評価ありがとうございました',
        submitFailed: '評価に失敗しました。再度試してください。',
      },
    },
    downloadPptRechargeModal: {
      title: 'レポートをダウンロードできません',
      desc1: '試用版ではレポートをダウンロードできません',
      desc2: '完全なレポートを取得するには、サブスクリプションしてください',
      btn: 'サブスクリプション',
    },
    checkInvitationCodeModal: {
      invitationCode: '紹介コード',
      invitationCodeDesc1: '紹介コードは変更できません。変更する場合は、お問い合わせください',
      invitationCodeDesc2: 'エージェント紹介を通じてご利用の場合は、紹介コードを入力してください',
      invitationCodePlaceholder: '紹介コードを入力してください',
      invitationCodeError: '無効な紹介コードです',
      invitationCodeSuccess: '紹介コードが正常に変更されました',
      ok: '確定',
      cancel: 'キャンセル',
    },
    aigcPromotionModal: {
      title: 'AIGCクリエイター特典',
      subTitle: 'ご登録でAI動画テスト<tmp>5</tmp>回分をプレゼント',
      desc1:
        'AIGCクリエイティブテストキャンペーンに参加して、AdEffであなたのAIGCクリエイティブを全方位評価しましょう！',
      desc2: '下のボタンからご登録いただくと、AIGCクリエイティブテスト5回分をすぐに無料でお受け取りいただけます。',
      registerBtn: '登録してテスト機会を取得',
      tip: 'AIGCクリエイターキャンペーン経由でご登録いただいた新規ユーザー様限定',
      floatTitle: '無料テスト',
    },
  },
}

export default TRANSLATION
